import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  makeStyles,
  InputLabel,
} from "@material-ui/core";
import {
  selectBussinesstype,
  getListofBussinesstype,
  set,
} from "./bussinesstypeSlice";
import { red } from "@material-ui/core/colors";
import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
    "&:hover": {
      boxShadow: "0 1px 1.5px rgba(0,0,0,0.16), 0 1px 1.5px rgba(0,0,0,0.23)",
    },
    transition: "box-shadow 0.75s",
  },
  textHilight: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
}));

export function Bussinesstype() {
  const classes = useStyles();
  const language = useSelector(selectLanguage);
  const currentBussinesstype = useSelector(selectBussinesstype);
  const listOfBussineestype = useSelector(getListofBussinesstype);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <FormControl required className={classes.formControl} variant="outlined">
      <InputLabel id="BussinessType-input-label">
        {" "}
        {language === "TH"
          ? "ประเภทธุรกิจของลูกค้า"
          : "Customer Bussiness Type"}{" "}
      </InputLabel>{" "}
      <Select
        labelId="BussinessType-input-label"
        id="BussinessType-input"
        value={currentBussinesstype}
        color="secondary"
        onChange={(e) => {
          dispatch(set(e.target.value));
        }}
        className={classes.selectEmpty}
      >
        <MenuItem value="" className={classes.textHilight}>
          <em> None </em>{" "}
        </MenuItem>{" "}
        {listOfBussineestype.map((bussinesstype) => {
          return (
            <MenuItem
              className={classes.textHilight}
              key={bussinesstype.Id}
              value={bussinesstype.Id}
            >
              {" "}
              {bussinesstype.Name}{" "}
            </MenuItem>
          );
        })}{" "}
      </Select>{" "}
      <FormHelperText> Required </FormHelperText>{" "}
    </FormControl>
  );
}
